import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { Settings } from '../settings.state';
import * as Objects from '@core/objects';

// some errors to manage
interface WorkflowErrors {
    set_workflow_transitions: HttpErrorResponse,
}

export interface SettingsWorkflows {
    workflows: Array<Objects.Workflow>;
    transitions: Array<Objects.WorkflowTransition>;
    initialized: {
        list: boolean;
        editor: boolean;
    };
    errors: WorkflowErrors;
}

export const initialState: SettingsWorkflows = {
    workflows: [],
    transitions: [],
    initialized: {
        list: false,
        editor: false
    },
    errors: {
        set_workflow_transitions: null
    }
};

const settingsFeatureSelector = createFeatureSelector('settings');

const settingsWorkflowsFeatureSelector = createSelector(
    settingsFeatureSelector,
    (state: Settings) => state.workflows
);

// Selectors
export const settingsWorkflowsSelector = createSelector(
    settingsWorkflowsFeatureSelector,
    (state: SettingsWorkflows) => state.workflows
);

export const transitionsSelector = createSelector(
    settingsWorkflowsFeatureSelector,
    (state: SettingsWorkflows) => state.transitions
);

export const initializedSelector = createSelector(
    settingsWorkflowsFeatureSelector,
    (state: SettingsWorkflows) => state.initialized
);

export const errorSelector = (key: string) => 
    createSelector(
        settingsWorkflowsFeatureSelector,
        (state: SettingsWorkflows) => state.errors.hasOwnProperty(key) ? state.errors[key] : null
    );
